<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.5" y="5" width="15" height="12.5" rx="2" stroke="#AFAFBE" class="stroke" />
    <path
      d="M2.5 8.33333C2.5 7.08718 2.5 6.4641 2.76795 6C2.94349 5.69596 3.19596 5.44349 3.5 5.26795C3.9641 5 4.58718 5 5.83333 5H14.1667C15.4128 5 16.0359 5 16.5 5.26795C16.804 5.44349 17.0565 5.69596 17.2321 6C17.5 6.4641 17.5 7.08718 17.5 8.33333H2.5Z"
      fill="#AFAFBE"
      class="fill"
    />
    <path d="M5.83301 2.5L5.83301 5" stroke="#AFAFBE" class="stroke" stroke-linecap="round" />
    <path d="M14.167 2.5L14.167 5" stroke="#AFAFBE" class="stroke" stroke-linecap="round" />
    <rect x="5.83301" y="10" width="3.33333" height="1.4" rx="0.5" fill="#AFAFBE" class="fill" />
    <rect
      x="5.83301"
      y="13.3359"
      width="3.33333"
      height="1.4"
      rx="0.5"
      fill="#AFAFBE"
      class="fill"
    />
    <rect x="10.833" y="10" width="3.33333" height="1.4" rx="0.5" fill="#AFAFBE" class="fill" />
    <rect
      x="10.833"
      y="13.3359"
      width="3.33333"
      height="1.4"
      rx="0.5"
      fill="#AFAFBE"
      class="fill"
    />
  </svg>
</template>

<style lang="scss" scoped>
.fill {
  fill: #656c6f;
}

.stroke {
  stroke: #656c6f;
}
</style>
